import { QuestionType } from "../../../api/main/models/codeOnly/QuestionType";
import { CreateQuestionBase, EditQuestionBase } from "../edit/EditQuestionBase";

/**
 * Create a question.
 */
export const CreateQuestion = () => (
    <CreateQuestionBase
        defaultQuestionType={QuestionType.MultipleChoiceVideo}
        onCreateDefaultValues={() => ({ /* No defaults needed */ })}
    />);

/**
 * Edit a question.
 */
export const EditQuestion = () => (<EditQuestionBase defaultQuestionType={QuestionType.MultipleChoiceVideo} />);
